export enum AdminErrors {
  ChangePasswordFormValidation = "error:changepassword:formvalidation",

  CopyFromViktor = "error:copyfromviktor",
  CopyFromViktorCopyFailed = "error:copyfromviktor:copyfailed",
  CopyFromViktorFormValidation = "error:copyfromviktor:formvalidation",
  CopyFromViktorNewUserAlreadyExists = "error:copyfromviktor:newuseralreadyexists",

  EditAccount = "error:editaccount",
  EditAccountFormValidation = "error:editaccount:formvalidation",

  Login = "error:login",
  LoginExternalOrganisation = "error:login:externalorganisation",
  LoginFormValidation = "error:login:formvalidation",
  LoginImportedUser = "error:login:importeduser",
  LoginInvalid = "error:login:invalid",
  LoginLockedOut = "error:login:lockedout",
  LoginNotActive = "error:login:notactive",
  LoginNotAllowed = "error:login:notallowed",

  ResetPasswordFormValidation = "error:resetpassword:formvalidation",

  Transfer = "error:transferaccount",
  TransferFormValidation = "error:transferaccount:formvalidation",
  TransferNewUserAlreadyExists = "error:transferaccount:newuseralreadyexists",
  TransferUserNotFound = "error:transferaccount:usernotfound",

  OrgRegistrationAlreadyExists = "error:organisationregistration:alreadyexists",
  OrgRegistrationFormValidation = "error:organisationregistration:formvalidation",
  OrgRegistrationInvalidOTC = "error:organisationregistration:invalidonetimecode",
  OrgRegistrationNotSuitable = "error:organisationregistration:notsuitable",
  OrgRegistrationSuspectedBot = "error:organisationregistration:suspectedbot",
  OrgRegistrationTokenExpired = "error:organisationregistration:expiredtoken",
  OrgRegistrationUnsupportedCountry = "error:organisationregistration:unsupportedcountry",
  OrgRegistrationUserAlreadyExists = "error:organisationregistration:useralreadyexists",

  ResetPassword = "error:resetpassword",
  ResetPasswordInvalidAccount = "error:resetpassword:invalidaccount",
  ResetPasswordInvalidToken = "error:resetpassword:invalidtoken",

  // Opportunity Edit
  OpportunityEditDuplicateInternalReference = "error:opportunityedit:duplicateinternalreference",
  OpportunityEditFormValidation = "error:opportunityedit:formvalidation",
  OpportunityEditOrganisationInactive = "error:opportunityedit:organisationnotactive",

  // Application
  ApplicationEdit = "error:applicationedit",
  ApplicationEditFormValidation = "error:applicationedit:formvalidation",
  ApplicationRecipient = "error:applicationrecipient",
  ApplicationRecipientAlreadyExists = "error:applicationrecipient:alreadyexists",
  ApplicationRecipientValidation = "error:applicationrecipient:formvalidation",

  // Entity Add
  EntityAddAgencyNotFound = "error:agencyentitycreate:agencynotfound",
  EntityAddFormValidation = "error:agencyentitycreate:formvalidation",
  EntityAddNotAllowed = "error:agencyentitycreate:notallowed",
  EntityAddOrganiationNotFound = "error:agencyentitycreate:organisationnotfound",
  EntityAddOrganisationAlreadyExists = "error:agencyentitycreate:alreadyexists",
  EntityAddOrganisationAlreadyLinked = "error:agencyentitycreate:alreadylinked",
  EntityAddUserAlreadyExists = "error:agencyentitycreate:newuseralreadyexists",

  // Entity Connect
  EntityConnectAgencyNotFound = "error:memberconnect:agencynotfound",
  EntityConnectFormValidation = "error:memberconnect:formvalidation",
  EntityConnectNotAllowed = "error:memberconnect:notallowed",
  EntityConnectNotFound = "error:memberconnect:notfound",
  EntityConnectTokenExpired = "error:memberconnect:expiredtoken",
}

export enum AppErrors {
  FormValidation = "error:formvalidation",

  OpportunityNotFound = "error:opportunity:notfound",

  Organisation = "error:organisation",
  OrganisationNotFound = "error:organisation:notfound",

  ApplicationFormValidation = "error:application:formvalidation",
  ApplicationAlreadyExists = "error:application:alreadyexists",
  ApplicationLimitReached = "error:application:limitreached",
  ApplicationUnsupportedCountry = "error:application:unsupportedcountry",
  ApplicationInvalidOneTimeCode = "error:application:invalidonetimecode",

  Subscripion = "error:subscription",
  SubscriptionAlreadyExists = "error:subscription:alreadyexists",

  AdviceTips = "error:advicetips",
  AdviceTipsNotFound = "error:advicetips:notfound",

  ContactForm = "error:contact",
  ContactFormValidation = "error:contact:formvalidation",

  SignIn = "error:signin",

  Experience = "error:experience",
  ExperienceDelete = "error:experience:delete",
}

export enum SharedErrors {
  Application = "error:application",
  Opportunity = "error:opportunity",
}

type EnumValues<E> = E[keyof E];

export type ErrorList =
  | EnumValues<typeof AppErrors>
  | EnumValues<typeof AdminErrors>
  | EnumValues<typeof SharedErrors>;
